<template>
  <div class="add modal modal--default">
    <div
      class="modal__panel"
      :class="
        showAddCustomerServicesModal ? 'modal__panel--in' : 'modal__panel--out'
      "
    >
      <div class="modal__logo-wrapper">
        <div class="modal__logo"></div>
         </div>
      <div
        class="modal__close"
        @click="store.commit('setShowAddCustomerServicesModal', false)"
      ></div>

      <div class="add__new">{{ $t(`addCustomerServiceModal.${"title"}`) }}</div>

      <div class="add__title">
        {{ $t(`addCustomerServiceModal.${"subTitle"}`) }}
      </div>

      <div class="customers">
        <div class="customer" @click="showAddPolicyModal()" v-if="can('policy_create')">
          <div class="customer__icon customer__icon--policy"></div>
          <button class="add__button button button--default" >
            {{ $t(`addCustomerServiceModal.${"policyButton"}`) }}
          </button>
        </div>
        <div v-if="can('pendency_create') || can('note_create') || can('call_create') || can('mandate_access')" class="customer" @click="showActivityModalMethod()">
          <div class="customer__icon customer__icon--activities"></div>
          <button class="add__button button button--default">
            {{ $t(`addCustomerServiceModal.${"activityButton"}`) }}
          </button>
        </div>
        <div class="customer" @click="showPotentialPolicyModal()"  v-if="can('potential_policy_create')">
          <div class="customer__icon customer__icon--potential"></div>
          <button class="add__button button button--default" >
            {{ $t(`addCustomerServiceModal.${"potentialButton"}`) }}
          </button>
        </div>
        <div class="customer" @click="showTerminationModal()" v-if="can('termination_create')">
          <div class="customer__icon customer__icon--terminate"></div>
          <button class="add__button button button--default" >
            {{ $t(`addCustomerServiceModal.${"terminationButton"}`) }}
          </button>
        </div>
        <div v-if="can('customer_policy_offer_create')" class="customer" @click="showOfferModal()">
          <div class="customer__icon customer__icon--offer"></div>
          <button class="add__button button button--default" >
            {{ $t(`addCustomerServiceModal.${"offerButton"}`) }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";

// Component name definition
defineOptions({
  name: "AddCustomerServices"
});

const store = useStore();

// Computed properties (Mapping original Vuex Getters)
const showAddCustomerServicesModal = computed(() => store.getters.showAddCustomerServicesModal);
const isSuperAdmin = computed(() => store.getters.isSuperAdmin);
const customerTeamId = computed(() => store.getters.customer?.team_id
  ?? store.getters.customer?.team?.id
  ?? store.getters.customerDetails?.team_id
  ?? store.getters.customerDetails?.team?.id
  ?? null);
const can = (ability) => {
  if (isSuperAdmin.value) return true;
  return store.getters.hasTeamPermission(ability, customerTeamId.value);
};

// Operational Methods
const showAddPolicyModal = () => {
  store.commit("setShowAddCustomerServicesModal", false);
  store.commit("setShowAddPolicyModal", true);
};

const showTerminationModal = () => {
  store.commit("setShowAddCustomerServicesModal", false);
  store.commit("setShowTerminationModal", true);
};

const showOfferModal = () => {
  store.commit("setShowAddCustomerServicesModal", false);
  store.commit("setOfferToEdit", null);
  store.commit("setShowAddOfferModal", true);
};

const showPotentialPolicyModal = () => {
  store.commit("setShowAddCustomerServicesModal", false);
  store.commit("setShowAddPotentialPolicyModal", true);
};

const showActivityModalMethod = () => {
  store.commit("setShowAddCustomerServicesModal", false);
  store.commit("setShowAddActivityModal", true);
};
</script>

<style scoped lang="scss">
@use "../assets/scss/add-panel-modal";
</style>
